import ArrowRight from "./ArrowRight";
import Menu from "./Menu";

const Icon = {
  ArrowRight,
  Menu,
};

export default Icon;
